import getAggs from "./getAggs";
import { processAggregations } from "./es/processAggregations";
const getAggregations = async ({ aggregateType, searchEs, query, include, filterAggregations = [], slcCtlg = "", slcLang = "", }) => {
    const { aggregations } = await searchEs({
        size: 0,
        from: 0,
        query,
        aggs: getAggs({
            filterAggregations,
            include,
            catalogId: slcCtlg,
            languageId: slcLang,
        }),
    }, aggregateType);
    return processAggregations(aggregations);
};
export default getAggregations;
